import { createContext } from "react";

/**
 * Worker route contexts, extracted from ``worker.tsx`` so eagerly-loaded modules
 * (e.g. the OS app registry) can provide them without statically importing the
 * full worker route — keeping ``lazy(() => import("@/routes/worker"))`` effective.
 */

export const WorkerIdContext = createContext<string | undefined>(undefined);

export const WorkerConversationIdContext = createContext<string | undefined>(
  undefined,
);

export const WorkerConversationContext = createContext<
  | {
      conversationId: string | null;
      setConversationId: (id: string | null) => void;
    }
  | undefined
>(undefined);
